import { cn } from "@/lib/utils";

/** The DigiHome mark: lilac square with eight slanted ink bars - exact geometry from the supplied logo SVG. */
export const DigiHomeIcon = ({ className, size = 32, rounded = true }) => {
  const bars = [[45.0359, 36.7341], [42.5159, 51.0244], [47.5559, 22.4436], [18.6284, 36.7341], [29.3123, 51.0244], [34.3521, 22.4436], [16.1084, 51.0244], [21.1484, 22.4436]];
  return (
    <svg width={size} height={size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <rect width="60" height="60" rx={rounded ? 13 : 3.5} fill="#D496FF" />
      {bars.map(([x, y]) => <rect key={`${x}-${y}`} width="6.60155" height="14.5107" transform={`matrix(-1 0 0.173648 -0.984808 ${x} ${y})`} fill="#1F1F1F" />)}
    </svg>
  );
};

/** The digihome lockup from digihome.no (icon + wordmark). `tone` dark = white version for dark surfaces. */
export const DigiHomeLogo = ({ className, height = 20, tone = "light" }) => (
  <img src={tone === "dark" ? "/brand/digihome-hero-logo-white.svg" : "/brand/digihome-hero-logo.svg"} alt="digihome" style={{ height }} className={cn("w-auto select-none", className)} draggable={false} />
);

/**
 * Product lockup: "MagicAd" as a Right Grotesk wordmark, then "by" + the real digihome lockup (the only icon in the mark).
 * `size`: "lg" (landing nav/footer), "md" (auth / gates), "sm" (app shell). `tone` dark = white variant.
 */
const SIZES = {
  lg: { word: "text-[26px] sm:text-[28px]", by: "text-[13.5px]", logo: 20, gap: "gap-2.5" },
  md: { word: "text-[24px]", by: "text-[12.5px]", logo: 16, gap: "gap-2" },
  sm: { word: "text-[20px]", by: "text-[11.5px]", logo: 13, gap: "gap-1.5" },
};
export const MagicAdLogo = ({ className, size = "lg", compact = false, tone = "light" }) => {
  const s = SIZES[compact ? "sm" : size] || SIZES.lg;
  return (
    <span className={cn("inline-flex items-baseline", s.gap, className)} data-testid="magicad-logo">
      <span className={cn("font-heading font-bold leading-none tracking-[-0.035em]", s.word, tone === "dark" ? "text-white" : "text-foreground")}>MagicAd</span>
      <span className={cn("inline-flex items-baseline gap-1.5 font-medium leading-none", s.by, tone === "dark" ? "text-white/60" : "text-foreground/55")} data-testid="magicad-by-digihome">
        by <DigiHomeLogo height={s.logo} tone={tone} className="translate-y-[2px]" />
      </span>
    </span>
  );
};
